/**
 * 演示站 API — 批 6 包 G（契约见 kickoff 02 §8）。
 *
 * POST /api/demo/leads 免鉴权（auth 中间件按 路径+POST 豁免）；
 * 同 IP 限流 10 次/日，超限后端返回 code=4290（由 client 解包抛 ApiError）。
 */
import client from "./client";

/** 留资提交体。 */
export interface LeadPayload {
  company_name: string;
  contact: string;
  message?: string;
  source_page: string;
}

/** 提交留资 → 后端落库 lead 表，成功返回 { ok: true }。 */
export async function submitLead(payload: LeadPayload): Promise<{ ok: boolean }> {
  return client.post<unknown, { ok: boolean }>("/demo/leads", payload);
}
